import React, { Component } from 'react';

export default class BeforeAbout extends Component {
  render() {
    return (
      <section className='about'>
        <p className='about__p'>
          <span className='about__conference-name'>
            HappyDev-lite&nbsp;
          </span>
          &mdash;&nbsp;большая бесплатная конференция о&nbsp;настоящем и&nbsp;будущем&nbsp;IT
          в&nbsp;России и&nbsp;мире, которая проходит в&nbsp;шестой раз!
        </p>
        <p className='about__p'>
          Мы&nbsp;приглашаем только школьников и&nbsp;студентов, ещё не&nbsp;начавших свою IT-карьеру.
        </p>
        <p className='about__p'>
          Если вы&nbsp;уже не&nbsp;являетесь таковыми, то&nbsp;можете стать спонсором или докладчиком.
        </p>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/BeforeAbout.js